import { IconProps } from '@/shared/lib/types'
import { getStatusColors } from '@/shared/utils/getStatusColors'

export const OrderIcon = ({ status, className }: IconProps) => {
  const { fillColor, strokeColor } = getStatusColors(status)

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="20" fill={`${fillColor}`} />
      <path
        d="M29 17.5C29 13.729 28.999 12.344 27.828 11.172C26.657 10 24.771 10 21 10H19C15.229 10 13.344 10.001 12.172 11.172C11 12.343 11 14.229 11 18V22C11 25.771 11.001 27.656 12.172 28.828C13.343 30 15.229 30 19 30H21"
        stroke={`${strokeColor}`}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16 20H20M16 16H24M16 24H18"
        stroke={`${strokeColor}`}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M25.4001 29.6V29.3739M25.4001 26.1334C25.4001 23.8262 28.2001 24.403 28.2001 22.0963C28.2001 19.0346 22.6001 19.0346 22.6001 22.0963"
        stroke={`${strokeColor}`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
